module.exports = __webpack_public_path__ + "static/media/icono-bazteca.0d5f008f.png";